<template>
  <el-dialog
    title="召回原因"
    :visible.sync="isShow"
    destroy-on-close
    width="400px"
    @close="closeDialog"
  >
    <el-form ref="applyForm" :model="formData" :rules="rules" label-width="100px">
      <el-form-item prop="reason" class="reason-wrap">
        <el-input
          v-model="formData.reason"
          :autosize="{ minRows: 4, maxRows: 6}"
          type="textarea"
          placeholder="请输入召回原因"
          maxlength="200"
          show-word-limit
          style="width: 100%;"
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="mini" :loading="isLoading" @click="submitData">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { recallRefund } from '@/API';

export default {
  data () {
    return {
      isShow: false,
      formData: { telApprovalId: '', reason: '' },
      isLoading: false,
      rules: { reason: [{ required: true, message: '召回原因不能为空' }] }
    };
  },

  methods: {
    openDialog ({ telApprovalId }) {
      this.formData.telApprovalId = telApprovalId;
      this.isShow = true;
    },

    closeDialog () {
      this.isShow = false;
      this.$refs.applyForm.resetFields();
    },

    submitData () {
      this.$refs.applyForm.validate((vaild) => {
        if (vaild) {
          this.isLoading = true;
          recallRefund(this.formData)
            .then((res) => {
              this.isLoading = false;
              let { status, data } = res.data;
              if (status === '200') {
                this.closeDialog();
                this.$emit('on-ok', data);
              }
            }).catch(() => {
              this.isLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.reason-wrap ::v-deep .el-form-item__content{
  margin-left: 0 !important;
}
</style>
